<template>
  <el-dialog title="优先处理" :visible.sync="visible" width="640px" @close="onClose">
    <el-form ref="form" label-position="top" :model="form" :rules="rules">
      <el-form-item
        label="确认优先处理吗？确认之后可以直接卸货，请输入原因："
        prop="priority_reason"
      >
        <el-input
          type="textarea"
          clearable
          :autosize="{ minRows: 4, maxRows: 6 }"
          placeholder="请输入原因"
          v-model="form.priority_reason"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="onConfirm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      form: {},
      rules: {
        priority_reason: [
          { required: true, message: "处理原因不能为空", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    onOpen(booking_id) {
      this.form.booking_id = booking_id;
      this.visible = true;
    },
    onConfirm() {
      this.$refs.form.validate(v => {
        if (v) {
          this.onSubmit();
        }
      });
    },
    async onSubmit() {
      try {
        await this.$common.http({
          url: "/api/queue/admin/priority_unload",
          data: this.form
        });
        this.$emit('ok');
        this.visible = false;
      } catch (error) {}
    },
    onClose() {
      this.form = {};
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 0 20px;
}
</style>
